class IconWithTextCollapse extends HTMLElement {
  constructor() {
    super();
    this.desktopBreakpoint = 750;
    this.onResize = this.onResize.bind(this);
  }

  connectedCallback() {
    this.details = this.querySelectorAll('details');
    this.onResize();
    window.addEventListener('resize', this.onResize);
    this.details.forEach((detail) => {
      detail.addEventListener('toggle', this.onToggle.bind(this));
    });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize() {
    const isDesktop = window.innerWidth >= this.desktopBreakpoint;
    this.details.forEach((detail) => {
      detail.open = isDesktop;
    });
  }

  onToggle(event) {
    const isDesktop = window.innerWidth >= this.desktopBreakpoint;
    if (isDesktop) return;

    const openedDetail = event.target;
    if (!openedDetail.open) return;

    this.details.forEach((detail) => {
      if (detail !== openedDetail) {
        detail.open = false;
      }
    });
  }
}

customElements.define('icon-with-text-collapse', IconWithTextCollapse);
